import { defineComponent as I, watchEffect as S, ref as N, computed as m, provide as U, toRef as v, h as k } from "vue";
import { warnOnce as w } from "./ghl-ui.es877.js";
import x from "./ghl-ui.es878.js";
import G from "./ghl-ui.es901.js";
import P from "./ghl-ui.es726.js";
import { createInjectionKey as E } from "./ghl-ui.es920.js";
import { call as n } from "./ghl-ui.es907.js";
const _ = E("n-checkbox-group"), j = {
  min: Number,
  max: Number,
  size: String,
  value: Array,
  defaultValue: {
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}, b = I({
  name: "CheckboxGroup",
  props: j,
  setup(t) {
    process.env.NODE_ENV !== "production" && S(() => {
      t.onChange !== void 0 && w("checkbox-group", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: g
    } = x(t), p = G(t), {
      mergedSizeRef: y,
      mergedDisabledRef: h
    } = p, f = N(t.defaultValue), C = m(() => t.value), l = P(C, f), R = m(() => {
      var u;
      return ((u = l.value) === null || u === void 0 ? void 0 : u.length) || 0;
    }), A = m(() => Array.isArray(l.value) ? new Set(l.value) : /* @__PURE__ */ new Set());
    function T(u, e) {
      const {
        nTriggerFormInput: c,
        nTriggerFormChange: d
      } = p, {
        onChange: o,
        "onUpdate:value": a,
        onUpdateValue: i
      } = t;
      if (Array.isArray(l.value)) {
        const r = Array.from(l.value), s = r.findIndex((F) => F === e);
        u ? ~s || (r.push(e), i && n(i, r, {
          actionType: "check",
          value: e
        }), a && n(a, r, {
          actionType: "check",
          value: e
        }), c(), d(), f.value = r, o && n(o, r)) : ~s && (r.splice(s, 1), i && n(i, r, {
          actionType: "uncheck",
          value: e
        }), a && n(a, r, {
          actionType: "uncheck",
          value: e
        }), o && n(o, r), f.value = r, c(), d());
      } else
        u ? (i && n(i, [e], {
          actionType: "check",
          value: e
        }), a && n(a, [e], {
          actionType: "check",
          value: e
        }), o && n(o, [e]), f.value = [e], c(), d()) : (i && n(i, [], {
          actionType: "uncheck",
          value: e
        }), a && n(a, [], {
          actionType: "uncheck",
          value: e
        }), o && n(o, []), f.value = [], c(), d());
    }
    return U(_, {
      checkedCountRef: R,
      maxRef: v(t, "max"),
      minRef: v(t, "min"),
      valueSetRef: A,
      disabledRef: h,
      mergedSizeRef: y,
      toggleCheckbox: T
    }), {
      mergedClsPrefix: g
    };
  },
  render() {
    return k("div", {
      class: `${this.mergedClsPrefix}-checkbox-group`,
      role: "group"
    }, this.$slots);
  }
});
export {
  _ as checkboxGroupInjectionKey,
  j as checkboxGroupProps,
  b as default
};
